import { tagKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'
import type { TagOption } from '../internal/tag-options.ts'

export interface UseEntryTagsOptions {
  readonly ledgerId: () => string | undefined
  readonly enabled: () => boolean
}

export interface UseEntryTags {
  /** Server-ordered, most-used first - offer these before free text so a tag someone
   * already uses weekly does not get reinvented with different casing or spelling. */
  readonly tags: ComputedRef<readonly TagOption[]>
}

export function useEntryTags(options: UseEntryTagsOptions): UseEntryTags {
  const api = useApi()
  const active = computed(() => options.enabled() && options.ledgerId() !== undefined)

  const query = useQuery({
    queryKey: computed(() => tagKeys.list(options.ledgerId() ?? '')),
    queryFn: ({ signal }) => api.tags.list(options.ledgerId()!, signal),
    enabled: active,
    retry: false,
  })

  return { tags: computed(() => query.data.value ?? []) }
}
